<template>
  <ExportModal
    :job-id="ulid"
    :title="title"
    :is-data-loaded="isDataLoaded"
    @export-to="onExportTo"
  >
    <template #copy-options>
      <div class="d-flex">
        <div class="my-auto">
          Copy All Sections
        </div>

        <v-btn
          class="my-auto ml-auto"
          variant="flat"
          color="primary"
          rounded="lg"
          height="32"
          @click="onCopyAllFieldsClick"
        >
          Copy All
        </v-btn>
      </div>
    </template>
  </ExportModal>
</template>

<script setup>
import ExportModal from '@/components/editor/ExportModal.vue';
import { useCurrentJobProfile } from '@/stores/jobProfiles/currentJobProfile';

const props = defineProps({
  ulid: { type: [String, Number], default: '' },
  title: { type: String, default: '' },
  isDataLoaded: { type: Boolean, default: false },
});

const emits = defineEmits(['export-tracking-event']);

const { copyAllFieldsToClipboard } = useCurrentJobProfile();

const onCopyAllFieldsClick = () => {
  copyAllFieldsToClipboard(props.title);
  emits('export-tracking-event', { action: 'copyAllFields', args: { job: props } });
};

const onExportTo = (param, mixpanelVar) => {
  emits('export-tracking-event', {
    action: 'editorLinkClick',
    args: { label: `Export: ${mixpanelVar}` },
  });

  window.open(`/jobprofile/editor/download?ulid=${props.ulid}&format=${param}`);
};
</script>
